import React from "react";
import styled from "styled-components";
import { Control } from "react-hook-form";
import InputField from "components/UI/InputField/InputField";
import SubmitResetNav from "components/common/form/SubmitResetNav";
import FormFieldContainer from "components/layout/style/form/FormFieldContainer";
import { PHOTO_SERIES_TYPES } from "constant/photo_series/photo_series_type.constant";
import PhotoSeriesTypeSelect from "components/common/photo_series/PhotoSeriesTypeSelect/PhotoSeriesTypeSelect";
import GroupSelect from "components/common/dl_group/GroupSelect/GroupSelect";

export type PhotoSeriesFormState = {
  name: string;
  slug: string;
  desc: string;
  group: string;
  sType: string;
};

type PhotoSeriesFormProps = {
  control: Control<PhotoSeriesFormState>;
  errorText?: string;
  isEditMode?: boolean;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  onReset: () => void;
};

export const PHOTO_SERIES_EMPTY_FORM: PhotoSeriesFormState = {
  slug: "",
  name: "",
  desc: "",
  group: "",
  sType: PHOTO_SERIES_TYPES.FOTOGRAFIJE,
};

const PhotoSeriesForm = ({
  control,
  errorText = "",
  onSubmit,
  onReset,
}: PhotoSeriesFormProps) => {
  return (
    <Form onSubmit={onSubmit}>
      <FormFieldContainer>
        <InputField name="name" control={control} label="Naziv" id="name" />
      </FormFieldContainer>

      <FormFieldContainer>
        <InputField name="slug" control={control} label="Slug" id="slug" />
      </FormFieldContainer>

      <FormFieldContainer>
        <InputField
          name="desc"
          control={control}
          label="Opis"
          id="desc"
          multiline
          rows={3}
        />
      </FormFieldContainer>

      <FormFieldContainer>
        <PhotoSeriesTypeSelect name="sType" control={control} label="Tip" />
      </FormFieldContainer>

      <FormFieldContainer>
        <GroupSelect
          name="group"
          control={control}
          valueByField="slug"
          label="Odrednica"
        />
      </FormFieldContainer>

      {errorText !== "" && <ErrorText>{errorText}</ErrorText>}

      <Actions>
        <SubmitResetNav onReset={onReset} />
      </Actions>
    </Form>
  );
};

const Form = styled.form`
  width: 100%;
  max-width: 900px;
`;

const Actions = styled.div`
  margin-top: 2rem;
  display: flex;
  gap: 0.75rem;
`;

const Title = styled.h2`
  margin: 0 0 1rem;
`;

const ErrorText = styled.div`
  margin-top: 0.5rem;
  color: #b00020;
  font-weight: 600;
`;

export default PhotoSeriesForm;
